import { ErrorPage } from "@/components/ui/error-page";

export default function NotFound() {
  return (
    <ErrorPage
      code="404"
      title="Page Not Found"
      subtitle="The page you are looking for could not be found."
    />
  );
}